import { useState, useEffect } from 'react';
import IconUp from '../../icons/up';
import IconDown from '../../icons/down';
import IconHideAll from '../../icons/hide-all';
import IconExpandAll from '../../icons/expand-all';
import { MonitoringWarningGroupTypes } from './types';
import MonitoringWarningGroup from './monitoring-warning-group';

import cn from './styles.module.css';

export default function MonitoringWarningGroups({
  groups,
  currentEmployee,
  applyWarning,
  transactionsTypes,
  applyWarningInProgress,
  activePermissions,
  onResetTransactionWarningAction,
  resetPaymentOrderTransactionActionIsLoading,
  resetPaymentOrderTransactionActionIsSuccess,
  selectedWarningId,
  getPaymentOrderWarningsAction,
  selectedWarningGroup,
  paginationInProgress,
  hideAll,
  showPassed,
  hiddenGroupsIds,
  setHiddenGroupsIds,
  getWarningGroupBeneficiaries,
  beneficiariesIsLoading,
  warningsInfo,
  getPaymentOrderWarningById,
  isWarningByIdLoading,
  isWarningByIdFetching,
  selectedMonitoringRuleWarningId,
  hideApproveActions,
  hideRejectActions,
}: MonitoringWarningGroupTypes) {
  const [collapsed, setCollapsed] = useState(true);
  const [warningsHidden, setWarningsHidden] = useState(false);
  const [hiddenWarningGroupsIds, setHiddenWarningGroupsIds] = useState<
    string[]
  >([]);

  useEffect(() => {
    setWarningsHidden(hideAll);

    let nextHiddenGroups = ([] as string[]).concat(hiddenGroupsIds as string[]);

    if (hideAll) {
      setHiddenWarningGroupsIds(groups?.map((item) => item.id) as string[]);

      groups?.forEach((item) => nextHiddenGroups.push(item.id));
    } else {
      setHiddenWarningGroupsIds([]);

      nextHiddenGroups = nextHiddenGroups?.filter((item) =>
        groups?.every((group) => item !== group.id),
      );
    }

    if (setHiddenGroupsIds) {
      setHiddenGroupsIds(nextHiddenGroups);
    }
  }, [hideAll]);

  useEffect(() => {
    let nextHiddenGroups = ([] as string[]).concat(hiddenGroupsIds as string[]);

    if (!warningsHidden && hiddenWarningGroupsIds?.length === groups?.length) {
      setWarningsHidden(true);

      groups?.forEach((item) => nextHiddenGroups.push(item.id));
    } else if (warningsHidden && hiddenWarningGroupsIds?.length === 0) {
      setWarningsHidden(false);

      nextHiddenGroups = nextHiddenGroups?.filter((item) =>
        groups?.every((group) => item !== group.id),
      );
    }

    if (setHiddenGroupsIds) {
      setHiddenGroupsIds(nextHiddenGroups);
    }
  }, [warningsHidden, hiddenWarningGroupsIds]);

  return (
    <div className={cn.monitoringRulesWrapper}>
      <div className={cn.warningGroupTitle}>
        <button
          type="button"
          className={cn.warningGroupTitleButton}
          onClick={() => setCollapsed(!collapsed)}
        >
          <div className={cn.iconWrapper}>
            {collapsed ? <IconUp /> : <IconDown />}
          </div>
          Monitoring rules
        </button>
        <button
          type="button"
          className={cn.warningGroupCollapseButton}
          onClick={() => {
            setWarningsHidden(!warningsHidden);

            let nextHiddenGroups = ([] as string[]).concat(
              hiddenGroupsIds as string[],
            );

            if (!warningsHidden) {
              setHiddenWarningGroupsIds(
                groups?.map((item) => item.id) as string[],
              );

              groups?.forEach((item) => nextHiddenGroups.push(item.id));
            } else {
              setHiddenWarningGroupsIds([]);

              nextHiddenGroups = nextHiddenGroups?.filter((item) =>
                groups?.every((group) => item !== group.id),
              );
            }

            if (setHiddenGroupsIds) {
              setHiddenGroupsIds(nextHiddenGroups);
            }
          }}
        >
          <div className={cn.iconWrapper}>
            {!warningsHidden ? <IconHideAll /> : <IconExpandAll />}
          </div>
          <span>{!warningsHidden ? 'Hide All' : 'Expand All'}</span>
        </button>
      </div>
      {collapsed &&
        groups?.map((item) => (
          <MonitoringWarningGroup
            key={item.id}
            group={item}
            currentEmployee={currentEmployee}
            applyWarning={applyWarning}
            transactionsTypes={transactionsTypes}
            applyWarningInProgress={applyWarningInProgress}
            activePermissions={activePermissions}
            onResetTransactionWarningAction={onResetTransactionWarningAction}
            resetPaymentOrderTransactionActionIsLoading={
              resetPaymentOrderTransactionActionIsLoading
            }
            resetPaymentOrderTransactionActionIsSuccess={
              resetPaymentOrderTransactionActionIsSuccess
            }
            selectedWarningId={selectedWarningId}
            getPaymentOrderWarningsAction={getPaymentOrderWarningsAction}
            selectedWarningGroup={selectedWarningGroup}
            paginationInProgress={paginationInProgress}
            hideAll={hideAll}
            warningsHidden={warningsHidden}
            showPassed={showPassed}
            setHiddenWarningGroupsIds={setHiddenWarningGroupsIds}
            hiddenWarningGroupsIds={hiddenWarningGroupsIds}
            getWarningGroupBeneficiaries={getWarningGroupBeneficiaries}
            beneficiariesIsLoading={beneficiariesIsLoading}
            warningsTotal={warningsInfo?.groups[item.id]}
            getPaymentOrderWarningById={getPaymentOrderWarningById}
            isWarningByIdLoading={isWarningByIdLoading}
            isWarningByIdFetching={isWarningByIdFetching}
            selectedMonitoringRuleWarningId={selectedMonitoringRuleWarningId}
            hideApproveActions={hideApproveActions}
            hideRejectActions={hideRejectActions}
          />
        ))}
    </div>
  );
}
